<script lang="ts">
    import { _ } from "svelte-i18n";
    import { StaticLoader } from "../helpers/static";
</script>

<div class="md:container lg:max-w-[60%] mx-auto px-4 overscroll-auto bg-primary pt-1 pb-1">
    <h1 class="text-3xl mt-4 md:mt-12">{$_("about.title")}</h1>
    <div class="mt-4">
        <svelte:component this={StaticLoader('about', $_('code'))} />
    </div>
</div>